import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import session_45auth_45global from "/vercel/path0/middleware/session-auth.global.ts";
import user_45auth_45global from "/vercel/path0/middleware/user-auth.global.ts";
export const globalMiddleware = [
  validate,
  session_45auth_45global,
  user_45auth_45global
]
export const namedMiddleware = {}